import { StaticQuery, graphql } from "gatsby"

import FooterLogo from "../images/icons/footer-logo.svg"
import Privacy from '../images/privacy.svg'
import React from "react"
import TenjinLink from "./navbar/tenjinLink.js"

const Footer = () => (
  <StaticQuery
    query={graphql`
      query {
        allWpMenuItem(filter: {locations: {eq: FOOTER_MENU}, parentId: {eq: null}}  sort: {fields: order}) {
          edges {
            node {
              id
              parentId
              label
              url
              target
              order
              childItems {
                nodes {
                  id
                  parentId
                  label
                  url
                  target
                  order
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      let menuItems = []

      data.allWpMenuItem.edges.forEach(edge => {
        menuItems.push(edge.node)
      })
      const handleNoticeClick = (e) => {
        e.preventDefault();
        const linkToClick = document.querySelector('.iubenda-cs-uspr-link');
        if (linkToClick) {
          linkToClick.click();
        }
      };

      const handleSettingsClick = (e) => {
        e.preventDefault();
        window._iub.cs.api.openPreferences()
      };

      return (
        <div className="px-8 mt-20 text-white bg-get-more-primary bg-no-repeat bg-center flex-shrink-0">
          <div className="max-w-screen-xl mx-auto pt-12 pb-6 lg:pt-28 lg:pb-12 md:max-w-2xl lg:px-0 lg:max-w-4xl xl:max-w-7xl 2xl:max-w-screen-2xl">
            <div className="">
              <div className="flex flex-wrap -mx-gutter">
                <div className="w-full pb-6 px-gutter md:w-1/5 overflow-hidden">
                  <img src={FooterLogo} style={{width: 156, height: 27}} alt="Fullstack Logo"></img>
                </div>

                {menuItems.map((item, index) => {
                  return (
                    <div key={index} className="w-1/2 pb-6 md:w-1/5 px-gutter">
                      <h4 className="pb-3">
                        <TenjinLink
                          item={item}
                          className="font-medium text-base"
                        />
                      </h4>
                      {item.childItems.nodes !== null ? (
                        <ul>
                          {item.childItems.nodes.map(
                            (subItem, subItemIndex) => {
                              return (
                                <li key={subItemIndex} className="pb-2 text-base font-light leading-relaxed truncate">
                                  <TenjinLink
                                    item={subItem}
                                    className="text-base"
                                  />
                                </li>
                              )
                            }
                          )}
                        </ul>
                      ) : (
                        ``
                      )}
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="w-full bg-white mt-10" style={{height: 1}}></div>
            <div className="flex justify-center text-center -mx-gutter pt-6">
              <p className="text-base font-light opacity-80 leading-relaxed">
                © {(new Date().getFullYear())} Growth FullStack
              </p>
            </div>
            <div className="mt-6" style={{
              color: "#fff",
              padding: ".5em",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "-apple-system,sans-serif !important",
              fontSize: "10px",
              fontWeight: 700
            }}>
              <div style={{
                border: "1px solid currentColor",
                borderRadius: "5px",
                overflow: "hidden",
                display: "flex",
              }}>
                <a href={'#'} onClick={handleNoticeClick}
                   style={{
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                     padding: ".5em 1em",
                     lineHeight: 1,
                     textDecoration: "none",
                     transition: "background-color .3s ease",
                     cursor: "pointer",
                   }}
                >Notice at Collection</a>
                <a href={'#'} onClick={handleSettingsClick}
                   style={{
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                     padding: ".5em 1em",
                     lineHeight: 1,
                     textDecoration: "none",
                     transition: "background-color .3s ease",
                     cursor: "pointer",
                     borderLeft: "1px solid currentColor",
                   }}
                >
                  Your Privacy Choices
                  <img style={{width: "2rem", marginLeft: "0.8rem"}} src={Privacy} alt="California Consumer Privacy Act (CCPA) Opt-Out Icon"/>
                </a>
              </div>
            </div>
          </div>
        </div>
      )
    }}
  />
)

export default Footer
